import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { createPromotionalSummaryCard } from './PromotionalSummaryCard';
import { PROMOTIONAL_SUMMARY_CARD_BASE_CLASSNAME } from './Constants';
createComponents(".".concat(PROMOTIONAL_SUMMARY_CARD_BASE_CLASSNAME), createPromotionalSummaryCard, NO_PATTERN_BUSINESS_LOGIC);
